import { z } from "zod";

export const RequestTypeOdvetvieDtoSchema = z.object({
    requestTypeId: z.number(),
    odvetvieId: z.number(),
    isBlacklist: z.boolean().nullish(),
});

export type RequestTypeOdvetvieDto = z.infer<typeof RequestTypeOdvetvieDtoSchema>;